/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { BikeleasingContractBenefitInKindDTO } from './bikeleasing-contract-benefit-in-kind-dto';
import { BikeleasingContractDetailsDTOAdditionalInformation } from './bikeleasing-contract-details-dtoadditional-information';
import { BikeleasingContractEmployeeDTO } from './bikeleasing-contract-employee-dto';
import { BikeleasingContractEmployerDTO } from './bikeleasing-contract-employer-dto';
import { BikeleasingContractEndOfLeasingTermDTO } from './bikeleasing-contract-end-of-leasing-term-dto';
import { BikeleasingContractInspectionDTO } from './bikeleasing-contract-inspection-dto';
import { BikeleasingContractLeasingDataDTO } from './bikeleasing-contract-leasing-data-dto';
import { BikeleasingContractLeasingRateDTO } from './bikeleasing-contract-leasing-rate-dto';
import { BikeleasingContractReplacementOfferDataDTO } from './bikeleasing-contract-replacement-offer-data-dto';
import { BikeleasingContractRetailerDTO } from './bikeleasing-contract-retailer-dto';
import { BikeleasingContractWearInsuranceDTO } from './bikeleasing-contract-wear-insurance-dto';
import { BikeleasingV2AccessoriesDTO } from './bikeleasing-v2-accessories-dto';
import { BikeleasingV2BikeDetailsDTO } from './bikeleasing-v2-bike-details-dto';

/**
 * 
 * @export
 * @interface BikeleasingContractDetailsDTO
 */
export interface BikeleasingContractDetailsDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof BikeleasingContractDetailsDTO
     */
    'insuranceCoverage': Array<BikeleasingContractDetailsDTOInsuranceCoverageEnum>;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'status'?: BikeleasingContractDetailsDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'contractNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'referenceNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof BikeleasingContractDetailsDTO
     */
    'remainingContractTerm'?: number;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'internalNoteCompany'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BikeleasingContractDetailsDTO
     */
    'hasDigitalTransferCode'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BikeleasingContractDetailsDTO
     */
    'isSchufaAgreement'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'signaturItStatusEmployee'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'signaturItStatusEmployer'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'signaturItStatusSelfEmployed'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employeeSignatureUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employerSignatureUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employerSignature'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BikeleasingContractDetailsDTO
     */
    'calculatedCurrentInsuranceYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'releaseStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'applicationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'notice'?: string;
    /**
     * 
     * @type {BikeleasingV2BikeDetailsDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'bike': BikeleasingV2BikeDetailsDTO;
    /**
     * 
     * @type {BikeleasingV2AccessoriesDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'accessories': BikeleasingV2AccessoriesDTO;
    /**
     * 
     * @type {BikeleasingContractEmployeeDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employee': BikeleasingContractEmployeeDTO;
    /**
     * 
     * @type {BikeleasingContractEmployerDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'employer': BikeleasingContractEmployerDTO;
    /**
     * 
     * @type {BikeleasingContractLeasingRateDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'leasingRate': BikeleasingContractLeasingRateDTO;
    /**
     * 
     * @type {BikeleasingContractBenefitInKindDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'benefitInKind': BikeleasingContractBenefitInKindDTO;
    /**
     * 
     * @type {number}
     * @memberof BikeleasingContractDetailsDTO
     */
    'leasingDuration'?: number;
    /**
     * 
     * @type {BikeleasingContractLeasingDataDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'leasingData': BikeleasingContractLeasingDataDTO;
    /**
     * 
     * @type {BikeleasingContractWearInsuranceDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'wearInsurance': BikeleasingContractWearInsuranceDTO;
    /**
     * 
     * @type {Array<BikeleasingContractInspectionDTO>}
     * @memberof BikeleasingContractDetailsDTO
     */
    'inspections': Array<BikeleasingContractInspectionDTO>;
    /**
     * 
     * @type {BikeleasingContractEndOfLeasingTermDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'endOfLeasingTerm': BikeleasingContractEndOfLeasingTermDTO;
    /**
     * 
     * @type {BikeleasingContractReplacementOfferDataDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'replacementOfferData': BikeleasingContractReplacementOfferDataDTO;
    /**
     * 
     * @type {BikeleasingContractDetailsDTOAdditionalInformation}
     * @memberof BikeleasingContractDetailsDTO
     */
    'additionalInformation': BikeleasingContractDetailsDTOAdditionalInformation;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'transferDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractDetailsDTO
     */
    'endDate'?: string;
    /**
     * 
     * @type {BikeleasingContractRetailerDTO}
     * @memberof BikeleasingContractDetailsDTO
     */
    'retailer'?: BikeleasingContractRetailerDTO;
}

export const BikeleasingContractDetailsDTOInsuranceCoverageEnum = {
    PremiumPlus: 'premium_plus',
    InspectionPlus: 'inspection_plus'
} as const;

export type BikeleasingContractDetailsDTOInsuranceCoverageEnum = typeof BikeleasingContractDetailsDTOInsuranceCoverageEnum[keyof typeof BikeleasingContractDetailsDTOInsuranceCoverageEnum];
export const BikeleasingContractDetailsDTOStatusEnum = {
    EmployeeApprovalRequired: 'EMPLOYEE_APPROVAL_REQUIRED',
    EmployerApprovalRequired: 'EMPLOYER_APPROVAL_REQUIRED',
    CancelledOrRejected: 'CANCELLED_OR_REJECTED',
    EmployerApprovalDone: 'EMPLOYER_APPROVAL_DONE',
    BikeTransferRequired: 'BIKE_TRANSFER_REQUIRED',
    BikeTransferDone: 'BIKE_TRANSFER_DONE',
    Active: 'ACTIVE',
    Expiring: 'EXPIRING',
    Finished: 'FINISHED',
    Requested: 'REQUESTED',
    BikeShipped: 'BIKE_SHIPPED'
} as const;

export type BikeleasingContractDetailsDTOStatusEnum = typeof BikeleasingContractDetailsDTOStatusEnum[keyof typeof BikeleasingContractDetailsDTOStatusEnum];


